module.exports = __webpack_public_path__ + "static/media/Phoenix_(Full).9738f0b3.png";